import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import StyledButton from './styled/button'
import Content from './content'

const Button = React.forwardRef((props, ref) => {
  const {
    // 样式
    style = {},
    className,
    size,
    borderColor,
    textColor,
    backgroundColor,
    // 状态
    disabled,
    loading,
    // 类型
    type, // follow 跟随 stroke 描边
    stroke, // 是否描边
    opacityType = 'full', // sm transparent
    clickType,
    // 内容
    label,
    children,
    // 事件
    onClick,
    onMouseEnter,
    onMouseLeave,
    icon,
  } = props

  return (
    <StyledButton
      ref={ref}
      style={style}
      className={clsx(
        'cursor-pointer',
        opacityType === 'full' && 'text-white border-transparent',
        opacityType === 'transparent' && `bg-transparent`,
        type === 'primary' &&
          !stroke &&
          opacityType !== 'transparent' &&
          `bg-primary-700 border-transparent text-white`,
        type === 'primary' &&
          !stroke &&
          opacityType === 'transparent' &&
          'text-primary-700',
        type === 'primary' &&
          stroke &&
          `bg-white border-primary-700 text-primary-700`,
        type !== 'stroke' &&
          type !== 'follow' &&
          !stroke &&
          opacityType === 'transparent' &&
          'border-transparent',
        type === 'warning' &&
          !stroke &&
          opacityType !== 'transparent' &&
          `bg-warning-700 border-transparent text-white`,
        type === 'warning' &&
          !stroke &&
          opacityType === 'transparent' &&
          'text-warning-700',
        type === 'warning' &&
          stroke &&
          `bg-white border-warning-700 text-warning-700`,
        type === 'success' &&
          !stroke &&
          opacityType !== 'transparent' &&
          `bg-success-700 border-transparent text-white`,
        type === 'success' &&
          !stroke &&
          opacityType === 'transparent' &&
          'text-success-700',
        type === 'success' &&
          stroke &&
          `bg-white border-success-700 text-success-700`,
        type === 'error' &&
          !stroke &&
          opacityType !== 'transparent' &&
          `bg-error-700 border-transparent text-white`,
        type === 'error' &&
          !stroke &&
          opacityType === 'transparent' &&
          'text-error-700',
        type === 'error' &&
          stroke &&
          `bg-white border-error-700 text-error-700`,
        type === 'follow' && 'bg-neutral-300 text-neutral-1200',
        !type && 'bg-white',
        !type && stroke && 'bg-white text-neutral-1200 border-neutral-400',
        className
      )}
      opacityType={opacityType}
      textColor={textColor}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      disabled={disabled || loading}
      $loading={loading}
      showType={type}
      type={clickType}
      $stroke={stroke}
      size={size}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Content
        size={size}
        label={label}
        loading={loading}
        type={type}
        opacityType={opacityType}
        textColor={textColor}
        backgroundColor={backgroundColor}
        icon={icon}
      >
        {children}
      </Content>
    </StyledButton>
  )
})

Button.propTypes = {
  icon: PropTypes.node,
  // style: PropTypes.shape(PropTypes.object),
  className: PropTypes.string,
  size: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  opacityType: PropTypes.string,
  clickType: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

Button.defaultProps = {
  icon: undefined,
  // style: {},
  className: undefined,
  size: 'md',
  borderColor: undefined,
  textColor: undefined,
  backgroundColor: undefined,
  disabled: false,
  loading: false,
  type: undefined,
  opacityType: 'full',
  clickType: 'button',
  label: undefined,
  children: undefined,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
}

Button.displayName = 'Button'

export default Button
